<template>
  <div class="onboarding-signup-step-phone">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.PHONE.@TITLE")) }}
          </h2>

          <Phone v-model:phone="form.phone" :i-model="ISignup" />

          <ExtraTipbox>
            <span>{{ $t("ETAB.PAGES.SIGNUP.STEPS.MAIN.PHONE.@HELPER") }}</span>
          </ExtraTipbox>
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { onMounted, ref } from "vue";
  import { ISignup } from "@core/models";
  import { useTransition } from "@core/composables";
  import { useSignup } from "@etab/composables";
  import Phone from "@etab/components/onboarding/signup/Phone.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();
  // Data
  const form = ref({ phone: null });

  // Methods
  const onSubmit = async function () {
    const signupStore = useSignupStore();
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step9_phone",
    });
    signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.phone]: form.value.phone });
    $_nextStep();
  };

  onMounted(() => {
    form.value.phone = signupStore[GETTER_SIGNUP_GET][ISignup.phone] || null;
  });
</script>

<style lang="scss">
  .onboarding-signup-step-phone {
    .extra-tipbox {
      margin-top: 40px;
    }
  }
</style>
